import React, { useEffect, useMemo, useState, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import { Card, CardHeader, CardBody, Input } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import licenseService from '../../../Services/licenseService';

const LicenseTable = ({ assetId, groupId }) => {
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [q, setQ] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchRows = useCallback(() => {
        if (!assetId && !groupId) return;
        setLoading(true);
        const req = groupId
            ? licenseService.listLicensesForGroup(groupId, { page, limit, q })
            : licenseService.listLicensesForAsset(assetId, { page, limit, q });
        req
            .then(res => {
                setRows(res.data.rows || []);
                setTotalRows(res.data.totalRows || 0);
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false));
    }, [assetId, groupId, page, limit, q]);

    useEffect(() => { fetchRows(); }, [fetchRows]);

    const statusBadge = (s) => {
        const klass =
            s === 'AVAILABLE' ? 'license-badge license-badge--available'
                : s === 'CONSUMED' ? 'license-badge license-badge--consumed'
                    : 'license-badge license-badge--void';
        return <span className={klass}>{s}</span>;
    };

    const columns = useMemo(() => [
        { name: 'License ID', selector: r => r.license_id, sortable: true, grow: 2 },
        {
            name: 'Store',
            selector: r => r.license_store_id
                ? `${r.license_store_id.tenant_store_name || ''}${r.license_store_id.tenant_unit_code ? ` (${r.license_store_id.tenant_unit_code})` : ''}`
                : '—',
            wrap: true, grow: 2
        },
        { name: 'Status', cell: r => statusBadge(r.license_status), sortable: true },
        {
            name: 'Consumed At',
            selector: r => r.license_consumed_at ? new Date(r.license_consumed_at).toLocaleString() : '—',
            sortable: true
        },
        {
            name: 'Type',
            cell: r => r.license_is_overdraft
                ? <span className='license-badge license-badge--overdraft'>OVERDRAFT</span>
                : <span className='license-badge license-badge--available'>POOL</span>
        },
        { name: 'PO#', selector: r => r.license_po_id ? r.license_po_id.po_number : '—' }
    ], []);

    return (
        <Card>
            <CardHeader>
                <div className='d-flex justify-content-between align-items-center flex-wrap'>
                    <H5 attrH5={{ className: 'mb-0' }}>License Ledger</H5>
                    <Input
                        style={{ maxWidth: 260 }}
                        placeholder='Search license ID…'
                        value={q}
                        onChange={e => { setPage(1); setQ(e.target.value); }}
                    />
                </div>
            </CardHeader>
            <CardBody>
                <DataTable
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    pagination paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={p => setPage(p)}
                    onChangeRowsPerPage={l => { setLimit(l); setPage(1); }}
                    paginationPerPage={limit}
                    highlightOnHover striped dense
                />
            </CardBody>
        </Card>
    );
};

export default LicenseTable;
